var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    fill: "#9786FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sms-icon_svg__clip0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.732 12.832l-2.899-2.38H4.845c-1.314 0-2.384-1.092-2.384-2.435V5.604c0-1.343 1.07-2.436 2.384-2.436h6.31c1.314 0 2.383 1.093 2.383 2.436v2.413c0 1.13-.757 2.095-1.806 2.362v2.453zM4.845 3.86c-.932 0-1.691.783-1.691 1.744v2.413c0 .961.759 1.743 1.691 1.743h4.236l1.959 1.608V9.784l.306-.036c.855-.1 1.5-.845 1.5-1.731V5.604c0-.961-.759-1.744-1.691-1.744h-6.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.434 7.22c.124.075.38.164.578.164.203 0 .287-.071.287-.181s-.066-.164-.318-.247c-.445-.15-.617-.393-.613-.649 0-.401.344-.705.878-.705.251 0 .476.057.609.123l-.12.463a1.056 1.056 0 00-.467-.123c-.163 0-.256.066-.256.176 0 .101.084.155.349.247.41.141.582.349.586.666 0 .401-.317.697-.935.697-.282 0-.534-.062-.697-.15l.12-.48zM6.353 6.338c0-.269-.01-.498-.018-.688h.564l.031.291h.013a.748.748 0 01.653-.34c.278 0 .498.142.591.367h.009a.963.963 0 01.278-.26.778.778 0 01.41-.106c.415 0 .728.29.728.935v1.27h-.653V6.634c0-.314-.102-.494-.318-.494a.328.328 0 00-.308.234.561.561 0 00-.027.172v1.26h-.652V6.599c0-.273-.097-.458-.31-.458-.171 0-.273.132-.312.242a.445.445 0 00-.027.168v1.257h-.652V6.338zM10.14 7.22c.124.075.38.164.578.164.203 0 .287-.071.287-.181s-.066-.164-.317-.247c-.446-.15-.618-.393-.614-.649 0-.401.345-.705.878-.705.252 0 .476.057.609.123l-.12.463a1.056 1.056 0 00-.467-.123c-.163 0-.256.066-.256.176 0 .101.084.155.349.247.41.141.582.349.586.666 0 .401-.317.697-.935.697-.282 0-.533-.062-.696-.15l.119-.48z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sms-icon_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.461 2.461h11.077v11.077H2.461z"
  })))));
}

export default __webpack_public_path__ + "./fonts/sms-icon.b031104f2eb7d018a4d98ab1ecc076e8.svg";
export { SvgSmsIcon as ReactComponent };